import { useDispatch } from "react-redux";
import Button from "../../../../UI/GeneralPurpose/Button";
import { UIactions } from "../../../../../store/slices/UI";

const UIText = {
  "es-CL": { label: "Cerrar" },
  "en-US": { label: "Close" },
};

const Close = () => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(UIactions.closeModal());
  };

  return <Button {...{ UIText, onClick, variant:'outlined' }} />;
};

export default Close;
